import { Box } from "@mui/material";
import React from "react";

const Coffee = (propse) => {
  return (
    <Box
      sx={{
        width: propse.Width < 560 ? "100%" : "25%",
        height: propse.Width < 560 ? "25%" : "100vh",
        backgroundColor: "#ffc300",
        marginLeft: propse.Width < 560 ? "0" : "75%",
        marginTop: propse.Width < 560 ? "75vh" : "0",
        display: propse.Width < 560 ? null : "flex",
        flexDirection: propse.Width < 560 ? null : "column",
        justifyContent: propse.Width < 560 ? null : "center",
      }}
    >
      <Box className="COFFEE1">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Aboreto",
            fontSize:
              propse.Width >= 560 && propse.Width < 768 ? "1rem" : "1.5rem",
            marginTop:
              propse.Width >= 560 && propse.Width < 1000 ? "400px" : "500px",
            marginLeft:
              propse.Width >= 560 && propse.Width < 768 ? "30px" : "30px",
          }}
        >
          <Box
            sx={{
              width:
                propse.Width >= 560 && propse.Width < 768 ? "100px" : "150px",
              height: "40px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            PORTFOLIO
          </Box>
          <Box
            sx={{
              width:
                propse.Width >= 560 && propse.Width < 768 ? "120px" : "170px",
              height: "40px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              backgroundColor: "white",
              color: "#ffc300",
              marginLeft: "8px",
            }}
          >
            LEITNER BOX
          </Box>
        </Box>
      </Box>
      <Box className="COFFEE2"></Box>
    </Box>
  );
};

export default Coffee;
